import { fetchData } from "./fetch";

export const getSettings = () => fetchData('GET', '/settings');

export const updateSettings = data => fetchData('POST', '/settings', data);
